import { ErrorHandler, Injectable } from '@angular/core';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  public handleError(error: unknown): void {
    const chunkFailedMessage = /Loading chunk [^\s]+ failed/;

    if (error instanceof Error && chunkFailedMessage.test(error.message)) {
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }

    // Log the error to console in development
    console.error('An error occurred:', error);
  }
}
